<template>
  <v-main v-if="loading" style="width:1920px;height:1080px;">
    <v-progress-circular
      :size="230"
      :width="20"
      :color="color1"
      indeterminate
      style="margin-left: 845px;margin-top:425px;opacity:30%;"
    />
  </v-main>
    <v-main v-else-if="isBannerScroll">
    <div
      :style="{ width: `${width}px` }"
    >
      <activity-page-banner-scroll
        v-if="pages && pages.length > 0"
        :activities="pages[0]"
        :titleDate="titleDate"
        :titleInfo="titleInfo"
        :color1="color1"
        :color2="color2"
        :cols="cols"
        :width="width"
        :height="height"
        :interval="interval"
      />
    </div>
    </v-main>
  <v-main v-else>
    <!--activity-page-row
      v-if="isRow && pages && pages.length === 1"
      :activities="pages[0]"
      :titleDate="titleDate"
      :titleInfo="titleInfo"
      :color1="color1"
      :color2="color2"
    /-->
    <!--activity-page-card 
      v-else-if="!isRow && pages"
      :activities="pages[0]"
      :titleDate="titleDate"
      :titleInfo="titleInfo"
      :color1="color1"
      :color2="color2"
    /-->
    <v-carousel
      v-if="pages && pages.length > 0"
      cycle
      light
      :width="width"
      :height="height"
      hide-delimiters
      :show-arrows="false"
      style="background-color: transparent !important;"
      :interval="interval"
    >
      <v-carousel-item
        v-for="(page, index) in pages"
        :key="index"
        :style=" { width: `${width}px !important` }"
      >
        <v-sheet
          style="background-color: transparent !important;"
        >
          <activity-page-banner
            v-if="isBanner"
            :activities="page"
            :titleDate="titleDate"
            :titleInfo="titleInfo"
            :color1="color1"
            :color2="color2"
            :cols="cols"
            :width="width"
            :height="height"
          />
          <activity-page-row
            v-else-if="isRow"
            :activities="page"
            :titleDate="titleDate"
            :titleInfo="titleInfo"
            :color1="color1"
            :color2="color2"
            :cols="cols"
            :width="width"
            :height="height"
          />
          <activity-page-card
            v-else
            :activities="page"
            :titleDate="titleDate"
            :titleInfo="titleInfo"
            :color1="color1"
            :color2="color2"
            :width="width"
            :height="height"
          />
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <no-pages v-else-if="!pages || pages.length === 0" wrap style="padding:100px"/>
    <!--v-layout v-else-if="!pages || pages.length === 0" wrap style="padding:100px">
      <v-flex
        xs12
        class="textAlert"
        :style="{ color: color1 }"
      >
        <center><b>NO HAY MÁS ACTIVIDADES PROGRAMADAS<br>PARA EL DÍA</b></center>
      </v-flex>
    </v-layout-->
  </v-main>
</template>

<script>
import axios from 'axios'
import utils from '@/services/utils'
import '@descubreDev/dg-activities/dg-activities.css'
//import { ActivityPageCard, ActivityPageRow } from '@descubreDev/dg-activities'
import ActivityPageCard from '@/components/lib/activityPageCard/Index'
import ActivityPageRow from '@/components/lib/activityPageRow/Index'
import ActivityPageBanner from '@/components/lib/activityPageBanner/Index'
import ActivityPageBannerScroll from '@/components/lib/activityPageBannerScroll/Index'
import NoPages from './NoPages'

// ?zoom=80&hotel=34&addDays=1&c1=tomato&c2=blue&c5=red&folder=wantudu

export default {
  name: 'Acttiv',

  components: {
    ActivityPageCard,
    ActivityPageRow,
    ActivityPageBanner,
    ActivityPageBannerScroll,
    NoPages,
  },
  data: () => ({
    //
    loading: true,
    titleDate: null,
    titleInfo: null,
    pages: null,
    activities: null,
    barceloConfig: null,
  }),
  computed: {
    interval () {
      const aux = utils.getParameterByName('interval')
      return aux ? aux : 10000
    },
    width () {
      const aux = utils.getParameterByName('w')
      return aux ? aux | 0 : 1920
    },
    height () {
      const aux = utils.getParameterByName('h')
      return aux ? aux | 0 : 1080
    },
    isBannerScroll () {
      return utils.getParameterByName('type') === 'bannerscroll'
    },
    isBanner () {
      return utils.getParameterByName('type') === 'banner'
    },
    isRow () {
      return utils.getParameterByName('type') === 'row'
    },
    isForceDate () {
      return utils.getParameterByName('fd') ? true : false
    },
    rows () {
      const aux = utils.getParameterByName('rows')
      return aux ? aux | 0 : 3
    },
    cols () {
      return utils.getParameterByName('cols') | 0
    },
    marginLeft () {
      return utils.getParameterByName('ml')
    },
    marginTop () {
      return utils.getParameterByName('mt')
    },
    color1 () {
      return utils.getParameterByName('c1') ? '#'.concat(utils.getParameterByName('c1')) : '#02443C'
    },
    color2 () {
      return utils.getParameterByName('c2') ? '#'.concat(utils.getParameterByName('c2')) : '#BF9D5A'
    },
    bgcolor () {
      return utils.getParameterByName('c5') ? '#'.concat(utils.getParameterByName('c5')) : null
    },
    folder () {
      return utils.getParameterByName('folder')
    },
    zoom () {
      let aux = utils.getParameterByName('zoom')
      aux = aux && aux.length > 0 ? parseInt(aux) : null
      return aux ? aux / 100 : null
    },
    hotel () {
      return utils.getParameterByName('hotel')
    },
    locale () {
      const aux = utils.getParameterByName('locale')
      return aux ? aux : 'es'
    },
    date() {
      const addDays = utils.getParameterByName('addDays')
      if (addDays) {
        let aux = new Date()
        aux.setDate(aux.getDate() + parseInt(addDays))
        return aux
      }
        
      let aux = utils.getParameterByName('date')
      if (!aux || aux.length === 0) aux = new Date()
      return aux
    },
    showAll () {
      return utils.getParameterByName('showAll')
    },
  },
  mounted () {
    this.loading = true
    if (this.marginLeft) document.getElementById('app').style.marginLeft = this.marginLeft.concat('px')
    if (this.marginTop) document.getElementById('app').style.marginTop = this.marginTop.concat('px')

    if (this.zoom) {
      document.body.style.zoom = this.zoom
      document.body.style.MozTransform = `scale(${this.zoom})`
      document.body.style.WebkitTransform = `scale(${this.zoom})`
      document.body.style.transformOrigin = 'left top'
    }
    if (this.bgcolor) document.body.style.backgroundColor = this.bgcolor
    this.handleGetBarceloConfig()
    //if (this.hotel && this.getFirstDay()) this.acctivLogin()
  },
  methods: {
    handleGetBarceloConfig () {
      const url = 'https://cm-booking-api.dview.es/v1/public/barcelo/'
      axios.get(url)
        .then(response => {
          this.barceloConfig = response.data
          if (this.hotel && this.getFirstDay()) this.acctivLogin()
        })
        .catch(error => {
          console.log('err', error)
        })
    },
    getIsToday() {
      if (this.isForceDate) return false
      return this.formatDate(this.date) === this.formatDate(new Date()) ? true : false
    },
    getIsTomorrow() {
      if (this.isForceDate) return false
      const aux = new Date()
      aux.setDate(aux.getDate() + 1)
      return this.formatDate(this.date) === this.formatDate(aux) ? true : false
    },
    formatDate(date, short) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()
    
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
    
      if (short) return [day, month].join('/')
      else return [year, month, day].join('-')
    },
    getFirstDay () {
      const d = new Date(this.date)
      const day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
      return this.formatDate(new Date(d.setDate(diff)))
    },
    getDay () {
      if(this.locale === 'en') return this.getIsToday() ? ' TODAY ' : this.getIsTomorrow() ? ' TOMORROW ' : ' '
      else if(this.locale === 'de') return this.getIsToday() ? ' HEUTE ' : this.getIsTomorrow() ? ' MORGEN ' : ' '
      else if(this.locale === 'fr') return this.getIsToday() ? " AUJOURD'HUI " : this.getIsTomorrow() ? ' MATIN ' : ' '

      return this.getIsToday() ? ' HOY ' : this.getIsTomorrow() ? 'MAÑANA' : ' '
    },
    getIsActive(st, et) {
      if (this.isForceDate) return false
      return st <= new Date() && et >= new Date()
    },
    getIsOld(value) {
      if (this.isForceDate) return false
      return value < new Date() ? true : false
    },
    acctivLogin () {
      const body = {
        login: 'Descubre',
        //pass: 'LSqfnVdFuiA'
        pass: '12345'
      }

      axios.put('https://intranet.acttiv.es/api-pias/v1/session/login', body, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        if (response && response.data.token) {
          const token = response.data.token
          this.acttivPias(token)
        }
      })
      .catch(error => {
        this.loading = false
        console.log('err', error)
      })
    },
    acttivLogout (token) {
      axios.delete('https://intranet.acttiv.es/api-pias/v1/session/logout', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        }
      })
      .then(response => {
        if (response.status === 201) console.log('Logout success') 
      })
      .catch(error => console.log('err', error))
    },
    async acttivPias (token) {
      try {

      
        const url = `https://intranet.acttiv.es/api-pias/v1/pias/pia?idHotel=${this.hotel}&fecha=${this.getFirstDay()}`
        const pias = await new Promise((resolve, reject) => axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
          }
        })
        .then(response => {
         if (response && response.status === 200  && response.data) {
          this.acttivLogout(token)
          resolve(response.data)
         } else resolve(null)
        })
        .catch(error => {
          this.acttivLogout(token)
          console.log('err', error)
          reject(error)
        }))

        if (pias) this.pages = await this.convertPiasData(pias)

      } catch (error) {
        console.log(error)
      }
    },
    urlExists(url) {
      try {
        const http = new XMLHttpRequest()
        http.open('HEAD', url, false)
        http.send()
        return http.status != 404
      } catch {
        return false
      }
    },
    replaceAll(string, search, replace) {
      return string ? string.split(search).join(replace) : ''
    },
    prepareImage(v) {
      let url = `https://www.dviewcontent.com/activity/acttiv/images/${this.folder ? this.folder : 'default'}/${this.formatImageName(v.nombre_tarea)}.jpg`
      
      if (!this.urlExists(url)) url = `https://www.dviewcontent.com/activity/acttiv/images/${this.folder ? this.folder : 'default'}/${v.codigo_categoria_actividad}.jpeg`
      const isPos20 = (new Date(v.hora_inicio).toTimeString().slice(0, 2) | 0) >= 20
      if (!this.urlExists(url) && isPos20) url = `https://www.dviewcontent.com/activity/acttiv/images/${this.folder ? this.folder : 'default'}/404.jpg`
      return url
    },
    formatImageName (value) {
      let aux = value
      aux = this.replaceAll(aux, ' ', '')
      aux = this.replaceAll(aux, '-', '')
      aux = this.replaceAll(aux, '_', '')
      aux = this.replaceAll(aux, 'á', 'a')
      aux = this.replaceAll(aux, 'é', 'e')
      aux = this.replaceAll(aux, 'í', 'i')
      aux = this.replaceAll(aux, 'ó', 'o')
      aux = this.replaceAll(aux, 'ú', 'u')
      aux = this.replaceAll(aux, 'ñ', 'n')
      return aux.toLowerCase()
    },
    async getImageActtiv (piaID, tareaID) {
      try {
        return await new Promise((resolve) => fetch(`https://acttiv-api.dtouchwebapp.com/v1/public/image/${piaID}/${tareaID}`)
        .then(response => response.json())
        .then(data => {
          resolve(data ? data.Image : null)
        })
        .catch(error => {
          resolve(null)
          console.log(error)
        }))
      } catch (error) {
        console.log(error)
        return null
      }
    },
    async convertPiasData (pia) {
      this.loading = true
      if (this.hotel === '1460') pia.nombre_hotel = pia.nombre_hotel.replace('Esmeralda Park', '')
      this.titleInfo = pia.nombre_hotel
      const d = new Date(this.date)
      this.titleDate = `${this.getDay()} ${d.getDate()}/${d.getMonth()+1}`

      let result = []
      for (const program of pia.programa_hotel) {
        for (const plan of program.dia_planif) {
          for (const tar of plan.tarea_pia) {
            const name = {
              es: tar.nombre_tarea_es ? tar.nombre_tarea_es : tar.nombre_tarea,
              en: tar.nombre_tarea_en ? tar.nombre_tarea_en : tar.nombre_tarea,
              de: tar.nombre_tarea_de ? tar.nombre_tarea_de : tar.nombre_tarea,
              fr: tar.nombre_tarea_fr ? tar.nombre_tarea_fr : tar.nombre_tarea,
            }
            const detail = {
              es: program.nombre_programa,
            }
            const startTime = new Date(tar.hora_inicio)
            const endTime = new Date(tar.hora_fin)
            //if (tar.nombre_tarea = 'Turo Disco')

            let subtitle = tar.nombre_categoria_actividad
            if (tar.lugar && tar.lugar !== '') subtitle = tar.lugar 
            if (tar.punto_encuentro && tar.punto_encuentro !== '') subtitle = tar.punto_encuentro
            const isBarcelo = this.barceloConfig.hotels.indexOf(this.hotel | 0) >= 0
            if (isBarcelo) {
              const aux = this.barceloConfig.subcategories.filter(x => x.key === tar.subcategorias)
              subtitle = aux.map(item => item.wetag).shift()
            }
            let image
            if (this.folder === 'acttiv') {
              image = await this.getImageActtiv(pia.id_pia, tar.id_tarea)
            } else {
              image = this.prepareImage(tar)
            }

            if (plan.fecha === this.formatDate(this.date)) {
              if(this.showOld || !this.getIsOld(endTime))
                result.push({
                  programID: program.id_programa_hotel,
                  programName: program.nombre_programa,
                  title: name[this.locale] ? name[this.locale] : tar.nombre_tarea,
                  //image: this.prepareImage(tar),
                  image,
                  time: `${startTime.toTimeString().slice(0, 5)} - ${endTime.toTimeString().slice(0, 5)}`,
                  subtitle,
                  detail: detail[this.locale] ? detail[this.locale] : null,
                  active: this.getIsActive(startTime, endTime),
                  old: this.getIsOld(endTime),
                  start: startTime,
                  color1: this.color1,
                  color2: this.color2,
                })
            }
          }
        }
      }
            
      result = result.filter(x => !x.OLD || this.showAll).slice().sort((a, b) => {
        return a.start - b.start
      })
     
      let pages = []
      if (this.isBannerScroll) {
        pages[0] = result
      } else if (this.isBanner) {
        let aux = []
        for (const item of result) {
          aux.push(item)
          if (aux.length === (this.rows)) {
            pages.push(aux)
            aux = []
          }
        }
        if (aux.length > 0 ) pages.push(aux)
      } else {
        let aux = []
        for (const item of result) {
          aux.push(item)
          if (aux.length === (this.rows * 2)) {
            pages.push(aux)
            aux = []
          }
        }
        if (aux.length > 0 ) pages.push(aux)
      }
      this.loading = false
      return pages
    },
  },
}
</script>

<style scoped>
#app {
  background: none;
}
</style>

